import React from 'react';
import { useNavigate } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { FiChevronDown, FiChevronRight } from 'react-icons/fi';
import { EmptyState } from '@/components/custom/empty-state';
import { Loader } from '@/components/custom/loader';
import EndScroll from '@/components/custom/end-scroll/end-scroll';
import { AvatarWrapper } from '@/components/ui/avatar';
import { PATHS } from '@/routes/paths';
import { formatInteger } from './formatters';

export function TeachersTable({ teachers = [], search, onSearchChange, sortDirection, onSortToggle, hasMore, onLoadMore, initialLoading }) {
  const navigate = useNavigate();

  return (
    <div>
      <div className="report-widget__filter mb-4">
        <input
          className="report-form__control report-form__control--md"
          aria-label="Pesquisar"
          placeholder="Pesquisar"
          type="search"
          value={search}
          onChange={e => onSearchChange(e.target.value)}
        />
      </div>

      {initialLoading ? (
        <Loader />
      ) : teachers.length === 0 ? (
        <EmptyState
          type="data"
          text="Nenhum professor encontrado"
        />
      ) : (
        <div className="round-dg-wrapper">
          <InfiniteScroll
            dataLength={teachers.length}
            next={onLoadMore}
            hasMore={hasMore}
            loader={<Loader />}
            endMessage={<EndScroll />}
          >
            <table className="round-dg round-dg--light min-w-[640px]">
              <thead className="round-dg__header">
                <tr className="round-dg__row">
                  <th className="round-dg__cell-header round-dg__cell-header--sm w-72">Professor</th>
                  <th className="round-dg__cell-header round-dg__cell-header--sm min-w-60">GRE/Instituição</th>
                  <th className="round-dg__cell-header round-dg__cell-header--sm w-40">
                    Ativações
                    <span
                      onClick={onSortToggle}
                      className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-1"
                    >
                      <FiChevronDown
                        style={{ transform: sortDirection === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
                        className="card__icon"
                      />
                    </span>
                  </th>
                  <th
                    className="round-dg__cell-header round-dg__cell-header--sm w-10"
                    aria-hidden="true"
                  />
                </tr>
              </thead>

              <tbody className="round-dg__body">
                {teachers.map(teacher => (
                  <tr
                    key={teacher.id}
                    className="round-dg__row u-cursor-pointer"
                    onClick={() => navigate(PATHS.REPORTS.TEACHER_LIVE_CHALLENGE(teacher.id))}
                  >
                    <th className="round-dg__cell-header round-dg__cell-header--sm round-dg__cell-header--row">
                      <div className="flex items-center gap-3">
                        <AvatarWrapper
                          size="xs"
                          src={teacher.avatar}
                          text={teacher.name}
                        />
                        <div className="min-w-0">
                          <p className="truncate font-semibold text-primary-dark">{teacher.name}</p>
                          <p className="truncate text-neutral">{teacher.email}</p>
                        </div>
                      </div>
                    </th>
                    <td className="round-dg__cell round-dg__cell--sm">
                      <p className="truncate">{teacher.gre}</p>
                    </td>
                    <td className="round-dg__cell round-dg__cell--sm">{formatInteger(teacher.activations)}</td>
                    <td className="round-dg__cell round-dg__cell--sm text-right">
                      <span className="card__icon-wrapper card__icon-wrapper--sm">
                        <FiChevronRight className="card__icon" />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </InfiniteScroll>
        </div>
      )}
    </div>
  );
}
